import { createAtom } from '@xstate/store';

export type HerState = {
	/** Whether the HER container is visible */
	isHerActive: boolean;
	/** Whether the container is in expanded mode */
	isExpanded: boolean;
	/** Whether the wave animation is playing */
	isAnimating: boolean;
	/** The content ID associated with the HER session */
	contentId: string | null;
	/** The cloud ID for the Atlassian instance */
	cloudID: string;
	/** Live text preview accumulated from streamed ANSWER_PART events */
	textPreview: string;
};

const initialState: HerState = {
	isHerActive: false,
	isExpanded: true,
	isAnimating: true,
	contentId: null,
	cloudID: '',
	textPreview: '',
};

export const herState = createAtom<HerState>(initialState);

export const toggleHer = (contentId?: string, cloudID?: string) => {
	herState.set((prevState) => ({
		...prevState,
		isHerActive: !prevState.isHerActive,
		// Reset to expanded when opening
		isExpanded: !prevState.isHerActive ? true : prevState.isExpanded,
		isAnimating: !prevState.isHerActive ? true : prevState.isAnimating,
		contentId: !prevState.isHerActive ? (contentId ?? null) : null,
		cloudID: !prevState.isHerActive ? (cloudID ?? prevState.cloudID) : prevState.cloudID,
		textPreview: !prevState.isHerActive ? '' : prevState.textPreview,
	}));
};

export const openHer = (contentId?: string, cloudID?: string) => {
	herState.set((prevState) => ({
		...prevState,
		isHerActive: true,
		isExpanded: true,
		isAnimating: true,
		contentId: contentId ?? null,
		cloudID: cloudID ?? prevState.cloudID,
	}));
};

export const closeHer = () => {
	herState.set((prevState) => ({
		...prevState,
		isHerActive: false,
		contentId: null,
		textPreview: '',
	}));
};

export const setExpanded = (expanded: boolean) => {
	herState.set((prevState) => ({
		...prevState,
		isExpanded: expanded,
	}));
};

export const setAnimating = (animating: boolean) => {
	herState.set((prevState) => ({
		...prevState,
		isAnimating: animating,
	}));
};

export const appendTextPreview = (text: string) => {
	herState.set((prevState) => ({
		...prevState,
		textPreview: prevState.textPreview + text,
	}));
};

export const clearTextPreview = () => {
	herState.set((prevState) => ({
		...prevState,
		textPreview: '',
	}));
};
